import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { Router } from '@angular/router';
import { ToasterServiceService } from '../../service/toaster.service';
import { MustMatch } from '../../service/must-match.service';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  conatct_number: any = FormGroup;
  otpForm: any = FormGroup;
  submitted = false;
  otpsubmitted = false;
  showPassword: boolean = false;
  showOtpFlag:boolean = false;
  setPasswordFlag:boolean = false;
  passwordForm: any = FormGroup;
  passwordSubmitted = false;
  confirmPassword: boolean = false;
  message: any;
  constructor(
    private location: Location,
    private fb: FormBuilder,
    private mainService: MainService,
    private router: Router,
    private toaterServiceService: ToasterServiceService) {
      this.conatct_number = this.fb.group({
        contactNumber: ['', [Validators.required,Validators.pattern("^[0-9]*$"),Validators.minLength(7)]],
      });

      this.otpForm = this.fb.group({
        otp: ['', [Validators.required, Validators.minLength(6),Validators.pattern("^[0-9]*$"),Validators.minLength(6)]]
      });

      this.passwordForm = this.fb.group({
        password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$_*]).{8,}$/)]],
        cpassword: ['', [Validators.required]]
      }, {
        validator: MustMatch('password', 'cpassword')
      });
  }

  goBackToPrevPage() {
    this.location.back();
  }

  get e() {
    return this.conatct_number.controls;
  }

  get g() {
    return this.otpForm.controls;
  }

  get f() {
    return this.passwordForm.controls;
  }
  getOtp() {
  this.submitted = true;
  this.message = "તમે તમારા ગામના કાર્યકર્તા ને સંપર્ક કરો.";
  this.showOtpFlag = true;
  }

  password() {
    this.showPassword = !this.showPassword
  }

  confirmPwd() {
    this.confirmPassword = !this.confirmPassword
  }

  otpKeyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  verifyOtp(){
    this.showOtpFlag = false;
    this.setPasswordFlag = true;
  }

  resetPassoword(){

  }

  
}
